import {classNames} from '@cohort/shared-frontend/utils/classNames';
import useThemeContext from '@cohort/wallet/hooks/useThemeContext';
import {getCohortTosUrl} from '@cohort/wallet/lib/Utils';
import type {CampaignStoreWDto} from '@cohort/wallet-schemas/campaign';
import React from 'react';
import {Trans} from 'react-i18next';

type CampaignTosProps = {
  campaign: CampaignStoreWDto;
  checked: boolean;
  setChecked: (checled: boolean) => void;
};

export const CampaignTos: React.FC<CampaignTosProps> = ({campaign, checked, setChecked}) => {
  const {hasDarkBg} = useThemeContext();

  return campaign.tosUrl === null ? (
    <label
      data-testid="cohort-only-tos"
      htmlFor="Tos"
      onClick={() => setChecked(!checked)}
      className={classNames('ml-2 block text-xs', hasDarkBg ? 'text-white/50' : 'text-black/50')}
    >
      <Trans
        i18nKey="store.checkout.campaignTos.acceptTosCohortOnly"
        ns="components"
        components={{
          cohortLink: (
            <a className="underline" href={getCohortTosUrl()} target="_blank" rel="noreferrer" />
          ),
        }}
      />
    </label>
  ) : (
    <label
      data-testid="cohort-and-merchant-tos"
      htmlFor="Tos"
      onClick={() => setChecked(!checked)}
      className={classNames('ml-2 block text-xs', hasDarkBg ? 'text-white/50' : 'text-black/50')}
    >
      <Trans
        i18nKey="store.checkout.campaignTos.acceptTosCohortAndMerchant"
        ns="components"
        values={{merchant: campaign.merchant.name}}
        components={{
          cohortLink: (
            <a className="underline" rel="noreferrer" href={getCohortTosUrl()} target="_blank" />
          ),
          merchantLink: (
            <a className="underline" href={campaign.tosUrl} target="_blank" rel="noreferrer" />
          ),
        }}
      />
    </label>
  );
};
